module.exports = __webpack_public_path__ + "img/joketrip-logo.01cf18c9.jpg";